
import React from 'react';
import { IconProps } from './IconProps';

const PointOfSaleIcon: React.FC<IconProps> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
    <path d="M12 11h.01" />
    <path d="M12 16h.01" />
    <path d="M8 11h.01" />
    <path d="M8 16h.01" />
    <path d="M16 11h.01" />
    <path d="M16 16h.01" />
    <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
  </svg>
);

export default PointOfSaleIcon;
